import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const Task = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="tech-leaders-task">
                <CommonTitle>Задачи</CommonTitle>
                <div className="case__ol-list  tech-leaders-task__ol-list">
                    <div className="case__ol-item__wrapper">
                        <div className="common__ol-item">
                            <span className="common__ol-number">1.</span>
                            <span className="common__ol-info">
                                Сделать не&nbsp;просто информационный сайт для ежегодного форума
                                со&nbsp;стандартными разделами, а&nbsp;сложную экосистему
                                с&nbsp;инструментами для моментальной передачи информации:
                            </span>
                        </div>
                        <div className="tech-leaders-task__icons-container">
                            <div className="tech-leaders-task__icons-item">
                                <div className="tech-leaders-task__icons-img">
                                    <img
                                        src="/images/svg/tech-leaders/tech-leaders-task__icons-img1.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className="tech-leaders-task__icons-text">Фотобанк</div>
                            </div>
                            <div className="tech-leaders-task__icons-item">
                                <div className="tech-leaders-task__icons-img">
                                    <img
                                        src="/images/svg/tech-leaders/tech-leaders-task__icons-img2.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className="tech-leaders-task__icons-text">Видеотрансляции</div>
                            </div>
                            <div className="tech-leaders-task__icons-item">
                                <div className="tech-leaders-task__icons-img">
                                    <img
                                        src="/images/svg/tech-leaders/tech-leaders-task__icons-img3.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className="tech-leaders-task__icons-text">
                                    Аудио-экскурсия города НТИ
                                </div>
                            </div>
                            <div className="tech-leaders-task__icons-item">
                                <div className="tech-leaders-task__icons-img">
                                    <img
                                        src="/images/svg/tech-leaders/tech-leaders-task__icons-img4.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className="tech-leaders-task__icons-text">Схема выставки</div>
                            </div>
                            <div className="tech-leaders-task__icons-item">
                                <div className="tech-leaders-task__icons-img">
                                    <img
                                        src="/images/svg/tech-leaders/tech-leaders-task__icons-img5.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <div className="tech-leaders-task__icons-text">
                                    Тестирование &laquo;дорожных карт&raquo;
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="common__ol-item">
                        <span className="common__ol-number">2.</span>
                        <span className="common__ol-info">
                            Сделать сайт для привлечения&nbsp;ЦА к&nbsp;участию в&nbsp;форуме.
                        </span>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Task;
